/* eslint-disable camelcase */
const seriesBuilder = (teamNames) => {
    if (teamNames?.away?.team?.name && teamNames?.home?.team?.name) {
        return `${teamNames.away.team.name.toLowerCase().replace(/\s+/g, '-')}-vs-${teamNames.home.team.name.toLowerCase().replace(/\s+/g, '-')}`;
    }
    return '';
};

const generateUUID = (env) => {
    let sessionID = sessionStorage.getItem('sessionID');
    if (!sessionID) {
        if (env === 'local') {
            sessionID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0; const v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v;
            });
        } else {
            sessionID = `${crypto.randomUUID()}`;
        }
    }
    sessionStorage.setItem('sessionID', sessionID);
    return sessionID;
};

export const buildAdParams = (params) => {
    const { media, teamNames, prerollType, source, env, season, publicaParams = {} } = params;

    // Destructure publicaParams for cleaner usage
    const {
        siteIds = {},
        site_name,
        site_page,
        custom_6
    } = publicaParams;

    // APS slots logic unchanged
    if (source === 'aps') {
        const slotCount = prerollType === 'midinning' ? 4 : 1;
        return {
            slots: Array.from({ length: slotCount }, (_, i) => ({
                slotID: prerollType === 'highlight'
                    ? 'mlbGamedayHighlightsSlot'
                    : `mlbGamedaySlot${i + 1}`,
                mediaType: 'video',
                sizes: [[640, 480]]
            }))
        };
    }

    const { contentId, title } = media;
    const isHighlight = prerollType === 'highlight';
    const isMidInning = prerollType === 'midinning';

    const siteId = isMidInning ? siteIds.midinning : siteIds.highlight;
    const contentSeason = `${season} ${site_name} Season`;

    return {
        site_id: siteId,
        format: 'json',
        site_name,
        adserver: 'gam',
        slot_count: isHighlight ? 1 : 4,
        ssai_enabled: 0,
        site_page,
        player_width: 1920,
        player_height: 1080,
        min_ad_duration: 0,
        max_ad_duration: 30,
        position: 'preroll',
        livestream: isHighlight ? 0 : 1,
        preferred_language: 'en',
        content_id: contentId,
        content_title: title,
        content_series: seriesBuilder(teamNames),
        content_season: contentSeason,
        session_id: generateUUID(env),
        custom_6,
        custom_7: 'maris',
        custom_9: 1, // index of midroll ads
        cb: parseInt(Math.random() * 1000000000, 10)
    };
};
